import { render } from "./AuthorComplete.vue?vue&type=template&id=bfc0c1e8&scoped=true&ts=true"
import script from "./AuthorComplete.vue?vue&type=script&lang=ts"
export * from "./AuthorComplete.vue?vue&type=script&lang=ts"

import "./AuthorComplete.vue?vue&type=style&index=0&id=bfc0c1e8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc0c1e8"]])

export default __exports__